import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import "@/assets/style/style.scss"
import { MotionPlugin } from '@vueuse/motion'
import { createPinia } from 'pinia'

const app = createApp(App)
const pinia = createPinia();

app.use(router).use(pinia).use(MotionPlugin).mount('#app')
